import React from 'react';
import PageLayout from '../../layout/PageLayout';
import KimCustomersDynamics from '../../layout/KimGroup/KimCustomersDynamics';

const KimCustomersDynamicsPage: React.FC = () => (
  <PageLayout>
    <KimCustomersDynamics />
  </PageLayout>
);

export default KimCustomersDynamicsPage;
